function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.391 14A1.38 1.38 0 010 12.632V1.368A1.38 1.38 0 011.391 0H14.61A1.38 1.38 0 0116 1.368v11.264A1.38 1.38 0 0114.609 14H1.39zM4.87 3.71a.345.345 0 00-.348-.342H1.739a.345.345 0 00-.348.343v8.578c0 .19.156.343.348.343h2.783a.345.345 0 00.348-.343V3.711zm4.87 0a.345.345 0 00-.349-.342H6.61a.345.345 0 00-.348.343v8.578c0 .19.156.343.348.343h2.78a.345.345 0 00.348-.343V3.711zm4.869 0a.345.345 0 00-.348-.342h-2.783a.345.345 0 00-.348.343v8.578c0 .19.156.343.348.343h2.783a.345.345 0 00.348-.343V3.711z"
});

var SvgColumns = function SvgColumns(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 14
  }, props), _ref);
};

export default SvgColumns;